module.exports = __webpack_public_path__ + "img/EDDP (EDDP).6ca39b35.png";